!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.DragDrop = e() : t.DragDrop = e();
}(window, function () {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(r, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "/", n(n.s = 0);
  }([function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "default", function () {
      return o;
    });
    n(1);

    function r(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    var o = function () {
      function t(e) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.editor = e, this.api = this.editor.blocks, this.holder = document.getElementById(this.editor.configuration.holder), this.startBlock = null, this.endBlock = null, this.setDragListener(), this.setDropListener();
      }

      var e, n, o;
      return e = t, (n = [{
        key: "setDragListener",
        value: function value() {
          var t = this,
              e = this.holder.querySelector(".ce-toolbar__settings-btn");
          e.setAttribute("draggable", "true"), e.addEventListener("dragstart", function () {
            t.startBlock = t.api.getCurrentBlockIndex();
          });
        }
      }, {
        key: "setDropListener",
        value: function value() {
          var t = this;
          document.addEventListener("drop", function (e) {
            var n = e.target;

            if (t.holder.contains(n)) {
              var r = t.getDropTarget(n);
              r && (t.endBlock = t.getTargetPosition(r), t.moveBlocks());
            }
          });
        }
      }, {
        key: "getDropTarget",
        value: function value(t) {
          return t.classList.contains("ce-block") ? t : t.closest(".ce-block");
        }
      }, {
        key: "getTargetPosition",
        value: function value(t) {
          return Array.from(t.parentNode.children).indexOf(t);
        }
      }, {
        key: "moveBlocks",
        value: function value() {
          this.api.move(this.endBlock, this.startBlock);
        }
      }]) && r(e.prototype, n), o && r(e, o), t;
    }();
  }, function (t, e, n) {
    var r = n(2);
    "string" == typeof r && (r = [[t.i, r, ""]]);
    var o = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, o);
    r.locals && (t.exports = r.locals);
  }, function (t, e, n) {
    (t.exports = n(3)(!1)).push([t.i, '.ce-block--drop-target .ce-block__content{\n  outline-color: #a0a0a0;\n  outline-style: dashed;\n  outline-width: 1px;\n}\n\n.ce-block--drop-target .ce-block__content:before {\n  content: "";\n  position: absolute;\n  top: 50%;\n  left: -20px;\n  margin-top: -1px;\n  height: 8px;\n  width: 8px;\n  border: solid #a0a0a0;\n  border-width: 1px 1px 0 0;\n  -webkit-transform-origin: right;\n  transform-origin: right;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.ce-block--drop-target .ce-block__content:after {\n  background: none;\n}', ""]);
  }, function (t, e) {
    t.exports = function (t) {
      var e = [];
      return e.toString = function () {
        return this.map(function (e) {
          var n = function (t, e) {
            var n = t[1] || "",
                r = t[3];
            if (!r) return n;

            if (e && "function" == typeof btoa) {
              var o = (a = r, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(a)))) + " */"),
                  i = r.sources.map(function (t) {
                return "/*# sourceURL=" + r.sourceRoot + t + " */";
              });
              return [n].concat(i).concat([o]).join("\n");
            }

            var a;
            return [n].join("\n");
          }(e, t);

          return e[2] ? "@media " + e[2] + "{" + n + "}" : n;
        }).join("");
      }, e.i = function (t, n) {
        "string" == typeof t && (t = [[null, t, ""]]);

        for (var r = {}, o = 0; o < this.length; o++) {
          var i = this[o][0];
          "number" == typeof i && (r[i] = !0);
        }

        for (o = 0; o < t.length; o++) {
          var a = t[o];
          "number" == typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), e.push(a));
        }
      }, e;
    };
  }, function (t, e, n) {
    var r,
        o,
        i = {},
        a = (r = function r() {
      return window && document && document.all && !window.atob;
    }, function () {
      return void 0 === o && (o = r.apply(this, arguments)), o;
    }),
        s = function s(t) {
      return document.querySelector(t);
    },
        c = function (t) {
      var e = {};
      return function (t) {
        if ("function" == typeof t) return t();

        if (void 0 === e[t]) {
          var n = s.call(this, t);
          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (t) {
            n = null;
          }
          e[t] = n;
        }

        return e[t];
      };
    }(),
        u = null,
        f = 0,
        l = [],
        p = n(5);

    function d(t, e) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n],
            o = i[r.id];

        if (o) {
          o.refs++;

          for (var a = 0; a < o.parts.length; a++) {
            o.parts[a](r.parts[a]);
          }

          for (; a < r.parts.length; a++) {
            o.parts.push(m(r.parts[a], e));
          }
        } else {
          var s = [];

          for (a = 0; a < r.parts.length; a++) {
            s.push(m(r.parts[a], e));
          }

          i[r.id] = {
            id: r.id,
            refs: 1,
            parts: s
          };
        }
      }
    }

    function h(t, e) {
      for (var n = [], r = {}, o = 0; o < t.length; o++) {
        var i = t[o],
            a = e.base ? i[0] + e.base : i[0],
            s = {
          css: i[1],
          media: i[2],
          sourceMap: i[3]
        };
        r[a] ? r[a].parts.push(s) : n.push(r[a] = {
          id: a,
          parts: [s]
        });
      }

      return n;
    }

    function b(t, e) {
      var n = c(t.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = l[l.length - 1];
      if ("top" === t.insertAt) r ? r.nextSibling ? n.insertBefore(e, r.nextSibling) : n.appendChild(e) : n.insertBefore(e, n.firstChild), l.push(e);else if ("bottom" === t.insertAt) n.appendChild(e);else {
        if ("object" != typeof t.insertAt || !t.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = c(t.insertInto + " " + t.insertAt.before);
        n.insertBefore(e, o);
      }
    }

    function v(t) {
      if (null === t.parentNode) return !1;
      t.parentNode.removeChild(t);
      var e = l.indexOf(t);
      e >= 0 && l.splice(e, 1);
    }

    function g(t) {
      var e = document.createElement("style");
      return void 0 === t.attrs.type && (t.attrs.type = "text/css"), y(e, t.attrs), b(t, e), e;
    }

    function y(t, e) {
      Object.keys(e).forEach(function (n) {
        t.setAttribute(n, e[n]);
      });
    }

    function m(t, e) {
      var n, r, o, i;

      if (e.transform && t.css) {
        if (!(i = e.transform(t.css))) return function () {};
        t.css = i;
      }

      if (e.singleton) {
        var a = f++;
        n = u || (u = g(e)), r = k.bind(null, n, a, !1), o = k.bind(null, n, a, !0);
      } else t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (t) {
        var e = document.createElement("link");
        return void 0 === t.attrs.type && (t.attrs.type = "text/css"), t.attrs.rel = "stylesheet", y(e, t.attrs), b(t, e), e;
      }(e), r = L.bind(null, n, e), o = function o() {
        v(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = g(e), r = j.bind(null, n), o = function o() {
        v(n);
      });

      return r(t), function (e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
          r(t = e);
        } else o();
      };
    }

    t.exports = function (t, e) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = a()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
      var n = h(t, e);
      return d(n, e), function (t) {
        for (var r = [], o = 0; o < n.length; o++) {
          var a = n[o];
          (s = i[a.id]).refs--, r.push(s);
        }

        t && d(h(t, e), e);

        for (o = 0; o < r.length; o++) {
          var s;

          if (0 === (s = r[o]).refs) {
            for (var c = 0; c < s.parts.length; c++) {
              s.parts[c]();
            }

            delete i[s.id];
          }
        }
      };
    };

    var w,
        x = (w = [], function (t, e) {
      return w[t] = e, w.filter(Boolean).join("\n");
    });

    function k(t, e, n, r) {
      var o = n ? "" : r.css;
      if (t.styleSheet) t.styleSheet.cssText = x(e, o);else {
        var i = document.createTextNode(o),
            a = t.childNodes;
        a[e] && t.removeChild(a[e]), a.length ? t.insertBefore(i, a[e]) : t.appendChild(i);
      }
    }

    function j(t, e) {
      var n = e.css,
          r = e.media;
      if (r && t.setAttribute("media", r), t.styleSheet) t.styleSheet.cssText = n;else {
        for (; t.firstChild;) {
          t.removeChild(t.firstChild);
        }

        t.appendChild(document.createTextNode(n));
      }
    }

    function L(t, e, n) {
      var r = n.css,
          o = n.sourceMap,
          i = void 0 === e.convertToAbsoluteUrls && o;
      (e.convertToAbsoluteUrls || i) && (r = p(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
      var a = new Blob([r], {
        type: "text/css"
      }),
          s = t.href;
      t.href = URL.createObjectURL(a), s && URL.revokeObjectURL(s);
    }
  }, function (t, e) {
    t.exports = function (t) {
      var e = "undefined" != typeof window && window.location;
      if (!e) throw new Error("fixUrls requires window.location");
      if (!t || "string" != typeof t) return t;
      var n = e.protocol + "//" + e.host,
          r = n + e.pathname.replace(/\/[^\/]*$/, "/");
      return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (t, e) {
        var o,
            i = e.trim().replace(/^"(.*)"$/, function (t, e) {
          return e;
        }).replace(/^'(.*)'$/, function (t, e) {
          return e;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i) ? t : (o = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? n + i : r + i.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
      });
    };
  }]).default;
});